const onHelpPopup = (path) => {
  const options = "top=150px, left=350px, width=1200px, height=700px";
  window.open(path, "_blank", options);
};

export default onHelpPopup;
